export default __webpack_public_path__ + "static/media/ownr_indirect.ce60207e.svg";